import { defineStore } from "pinia";
import { computed, ref } from "vue";
import api from "@/utils/axios";
import { useAuthStore } from "@/stores/auth";

export const useFeesAlertsStore = defineStore("feesAlerts", () => {
  const unpaidCount = ref(0);
  const loading = ref(false);
  let timer: ReturnType<typeof setInterval> | null = null;
  let seq = 0;

  const auth = useAuthStore();

  const isFamilyUser = computed(() => {
    const role = String(auth.user?.role || "");
    return role !== "" && !["ADMIN", "TECNICO"].includes(role);
  });

  const badgeLabel = computed(() =>
    unpaidCount.value > 99 ? "99+" : String(unpaidCount.value)
  );
  const hasUnpaid = computed(() => unpaidCount.value > 0);

  const refresh = async () => {
    if (!auth.isAuthenticated || !isFamilyUser.value) {
      unpaidCount.value = 0;
      return;
    }
    const mySeq = ++seq;
    loading.value = true;
    try {
      const res = await api.get("/fees/me/alerts");
      if (mySeq !== seq) return;
      unpaidCount.value = Number(res.data?.data?.unpaid_count || 0);
    } catch {
      /* silencioso */
    } finally {
      if (mySeq === seq) loading.value = false;
    }
  };

  const startPolling = () => {
    stopPolling();
    void refresh();
    timer = setInterval(() => void refresh(), 30000);
  };

  const stopPolling = () => {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  };

  return {
    unpaidCount,
    loading,
    isFamilyUser,
    badgeLabel,
    hasUnpaid,
    refresh,
    startPolling,
    stopPolling,
  };
});
